var map = {
	"./female/shadow/0_400.png": 146,
	"./male/shadow/0_400.png": 163
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1553;


//////////////////
// WEBPACK FOOTER
// ./src/layers ^\.\/.*\/shadow\/0_400\.png$
// module id = 1553
// module chunks = 0